export default __webpack_public_path__ + "static/media/logo-crucible.e1a514be.svg";